import { createWithEqualityFn } from 'zustand/traditional'
import axios from 'axios'
import { cleanParamsFilter } from 'Utils/cleanParamsFilter'

interface DashboardOperationalStore {
  projectStats: any
  projectPileStats: any
  projectPilingProgress: any[]
  getProjectStats: () => Promise<{ success: boolean; data: any }>
  getProjectPileStats: () => Promise<{ success: boolean; data: any }>
  getProjectPilingProgress: (from: string, to: string) => Promise<{ success: boolean; data: any }>
  clearState: () => void
}

export const API_SLUG = 'dashboardOperational'

export const useDashboardOperationalStore = createWithEqualityFn<DashboardOperationalStore>(
  (set, get) => ({
    projectStats: {},
    projectPileStats: {},
    projectPilingProgress: [],
    getProjectStats: async () => {
      return axios
        .get(`/${API_SLUG}/project/stats`)
        .then(response => {
          set({ projectStats: response.data })
          return { success: true, data: response.data }
        })
        .catch(error => {
          console.error('Error fetching project stats:', error)
          return { success: false, data: null }
        })
    },
    getProjectPileStats: async () => {
      return axios
        .get(`/${API_SLUG}/project/piles/stats`)
        .then(response => {
          set({ projectPileStats: response.data })
          return { success: true, data: response.data }
        })
        .catch(error => {
          console.error('Error fetching project pile stats:', error)
          return { success: false, data: null }
        })
    },
    getProjectPilingProgress: async (from: string, to: string) => {
      const params = cleanParamsFilter({ from, to })
      return axios
        .get(`/${API_SLUG}/project/piling-progress`, { params })
        .then(response => {
          set({ projectPilingProgress: response.data })
          return { success: true, data: response.data }
        })
        .catch(error => {
          console.error('Error fetching project piling progress:', error)
          return { success: false, data: null }
        })
    },
    clearState: () => {
      set({
        projectStats: {},
        projectPileStats: {},
        projectPilingProgress: [],
      })
    },
  })
)
